import { render, staticRenderFns } from "./SurveyQuestionEditorDatetime.vue?vue&type=template&id=1459a70c&"
import script from "./SurveyQuestionEditorDatetime.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionEditorDatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports